module.exports = __webpack_public_path__ + "static/media/minigame-fail.51383077.png";